import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardText,[_c(VSkeletonLoader,{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],ref:"skeleton",staticClass:"mx-auto",attrs:{"type":'table'}}),_c('pay-slip-component',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"pay_slip":_vm.paySlip}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }